// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2930":"9a647b6f","3211":"c8cad6eb","5744":"9a647b6f","9168":"c8cad6eb","9246":"c8cad6eb"}[chunkId] + ".chunk.css";
};